import React, { FC } from 'react';
import { Banner, Text } from '@tidbits/react-tidbits';
import { GlobalAlerts } from '../../store/alerts/types';

interface Props {
    alert: GlobalAlerts;
}

export const Alert: FC<Props> = ({ alert }) => {
    const { type, title, description, id } = alert;
    const variant = type === 'WARNING' ? 'warning' : 'standard';
    return (
        <Banner.Inline key={id} variant={variant} width={'95%'} dismissable>
            <Text textStyle="h5Emph" spaceBelow={['spacer15', 'spacer10']}>
                {title}
            </Text>
            <Text>{description}</Text>
        </Banner.Inline>
    )
}